import React, { useEffect, useRef, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Stack, TextField } from '@mui/material';
import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import JumboDemoCard from '@jumbo/components/JumboDemoCard';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { LoadingButton } from '@mui/lab';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import params from '../params';




const AccHead = () => {
  const [disbleButton, setDisbleButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataGroup, setdataGroup] = useState(null);
  const [dataHead, setdataHead] = useState(null);
  const [groupNameOptions, setGroupNameOptions] = useState({});

  const swal =useSwalWrapper()
  // [
  //   { "id":1, "GROUP_TYPE": "ASSETS", "GROUP_NAME": "Cash and Cash Equivalents", "ORD": 1 },
  //   { "id":2, "GROUP_TYPE": "ASSETS", "GROUP_NAME": "Accounts Receivable", "ORD": 2 },
  //   { "id":3, "GROUP_TYPE": "LIABILITY", "GROUP_NAME": "Accounts Payable", "ORD": 3 },
  //   { "id":4,"GROUP_TYPE": "INCOME", "GROUP_NAME": "Sales Revenue", "ORD": 4 },
  //   { "id":5,"GROUP_TYPE": "EXPENSE", "GROUP_NAME": "Operating Expenses", "ORD": 5 },
  //   { "id":6,"GROUP_TYPE": "INCOME", "GROUP_NAME": "Other Income", "ORD": 6 }
  // ]
  let Group_Type_value_opt=['LIABILITY', 'ASSETS', 'INCOME', 'EXPENSE']
  const fetchHeadDetail = async()=>{
    dataGroup && setdataGroup(null)
    setDisbleButton(true)
    await jwtAuthAxios.get('/acc/groups').then(res =>{
      setdataGroup(res.data)
      // Extract group type options
      const groupTypes = res.data.map((row) => row.GROUP_TYPE);
      const uniqueGroupTypes = [...new Set(groupTypes)];

      // Extract group name options for each group type
      const options = {};
      uniqueGroupTypes.forEach((type) => {
        const groupNames = res.data
          .filter((row) => row.GROUP_TYPE === type)
          .map((row) => ({GROUP_NAME:row.GROUP_NAME,GRP_CODE:row.GROUP_CODE}));
        options[type] = groupNames;
      });

      // Set the options state
      setGroupNameOptions(options);
      setDisbleButton(false)
    }).catch(r=>{
      // console.log(r);
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      })})
    await jwtAuthAxios.get('/acc/groupHeads').then(res =>{
      setdataHead(res.data)
      setDisbleButton(false)
    }).catch(r=>{
      // console.log(r);
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      })})
  }
  useEffect(fetchHeadDetail,[])
  // useEffect(()=>console.log(dataHead),[dataHead])
  // const CustomEditCellRenderer = (params) => {
  //   // console.log();
  //   // const handleChange = (event) => {
  //   //   // Invoke the onEdit callback with the new value when the input changes
  //   //   onEdit(id, field, event.target.value);
  //   // };
  //   // return 1
  //   return (
  //     <Autocomplete
  //               disablePortal
  //               id="auto_Group_Head"
  //               open
  //               getOptionLabel={(option) => option.GROUP_NAME}
  //               fullWidth
  //               onChange={(event, newValue) => {
  //                 setdataHead( dataHead.map((row) => row.ACH_CODE === params.id ? { ...row, ...newValue} : row));
  //             }}
  //               options={groupNameOptions[params.api.getCellValue(params.id,'GROUP_TYPE')]}
  //               renderInput={(params) => <TextField autoFocus {...params} label="Select Head" />}
  //           />
  //   );
  // };
  // renderEditCell:CustomEditCellRenderer
  const columns = [
    { field: "GROUP_TYPE", headerName: "Group Type",width:((window.innerWidth-90)*15)/100, type: 'singleSelect', valueOptions:Group_Type_value_opt,editable: true},
    { field: "GROUP_NAME", headerName: "Group Name",flex:1,width:((window.innerWidth-90)*72)/100,type: 'singleSelect',valueOptions:(params)=>groupNameOptions[params.row.GROUP_TYPE].map(s=>s.GROUP_NAME),editable: true},
    { field: "ACH_NAME", headerName: "Account Head Name",flex:1,width:((window.innerWidth-90)*72)/100, editable: true},
    { field: "ORD_NO", headerName: "Order", editable: true,width:((window.innerWidth-90)*10)/100,type: "number" }
  ];
  const addnewRow =()=>{
    try {
      
      setdataHead([...dataHead,{ "ACH_CODE":`new-${(dataHead?.length||0)+1}`,GROUP_TYPE: Group_Type_value_opt[0], "GROUP_NAME": groupNameOptions[Group_Type_value_opt[0]][0]['GROUP_NAME'],"GRP_CODE": groupNameOptions[Group_Type_value_opt[0]][0]['GRP_CODE'], "ORD": 0 }])
    } catch (error) {
      swal.fire({
        icon: 'error',
        text: error,
      })
    }
  }
  const handleEditCellChangeCommit = (params) => {
    const updateddataGroup = dataGroup.map((row) =>
      row.ACH_CODE === params.id ? { ...row, [params.field]: params.props.value } : row
    );
    setdataGroup(updateddataGroup);
  };
  const apiRef = useRef();

  const handleButtonClick = async (props) => {
    // Get all promises for updating rows
    setTimeout(async()=>{

    const updatedRows = await Promise.all(
      dataGroup.map(async (row) => {
        if (row.ACH_CODE === props.id) {
          const updatedCellValue = await apiRef.current.getCellValue(props.id, props.field);
          return { ...row, [props.field]: updatedCellValue };
        }
        return row;
      })
    );
    // console.log(updatedRows);
    setdataGroup(updatedRows);
    setDisbleButton(false)
  },100);
    // Update the state or perform other operations with updatedRows
  };
  
  const saveDataHandler= async()=>{
    setLoading(false)
    await jwtAuthAxios.post('/acc/groupHeads',{"groupHeads":dataHead}).then(res=>{
      swal.fire({
        icon: 'success',
        text: res.data.message,
      });
      fetchHeadDetail()
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      });    
      }).finally(e=>{
        setLoading(false)
      });    
  }

  const handleGroupTypeChange = (id, groupType,row,field) => {
    setTimeout(async()=>{
      // console.log();
      // 
      // console.log(apiRef.current.getCellValue(parmas.id, 'GROUP_NAME'));
      // apiRef.current.getCellValue(parmas.id, parmas.field)
    let GTValue= await apiRef.current.getCellValue(id, 'GROUP_TYPE');
    let FValue= await apiRef.current.getCellValue(id, field);
      if(await GTValue && await FValue && field == 'GROUP_TYPE'){
        const updateddataHead = dataHead.map((row) => {
          // console.log(groupNameOptions[`${GTValue}`]);
          if (row.ACH_CODE === id) {
            return { ...row, GROUP_TYPE: GTValue, GROUP_NAME: groupNameOptions[`${GTValue}`][0]['GROUP_NAME'],GRP_CODE: groupNameOptions[`${GTValue}`][0]['GRP_CODE']};
          }
          return row;
        });
        setdataHead(updateddataHead);
      } else if(await GTValue && await FValue && field == 'GROUP_NAME'){
        const updateddataHead = dataHead.map((row) => {
          if (row.ACH_CODE === id) {
            
            return { ...row, GRP_CODE:groupNameOptions[`${GTValue}`].find(row =>row.GROUP_NAME == FValue)['GRP_CODE'],GROUP_NAME:groupNameOptions[`${GTValue}`].find(row =>row.GROUP_NAME == FValue)['GROUP_NAME']};
          }
          return row;
        });
        setdataHead(updateddataHead);
      } else{
        const updateddataHead = dataHead.map((row) => {
          field == 'ACH_NAME' && setDisbleButton(!Boolean(FValue.trim()))
          if (row.ACH_CODE === id) {
            return { ...row,[field]:FValue};
          }
          return row;
        });
        setdataHead(updateddataHead);
      }
      },100);
  };

  return (
    <JumboCardQuick  action={<Stack direction={"row"} justifyContent={'end'} spacing={2}><Button variant='contained' disabled={disbleButton}  onClick={addnewRow}>Add new</Button><LoadingButton disabled={disbleButton} loading={loading} variant='contained' onClick={saveDataHandler}>Save</LoadingButton></Stack>} sx={{p:0}} title={'Account Head'} >

    <Paper elevation={0} sx={({backgroundColor: theme => theme.palette.action.hover,p:0})}>
    {!Boolean(dataHead) ? <TableSkeleton/>: <DataGrid
        rows={dataHead}
        columns={columns}
        // columns={columns.map((column) => {
        //   if (column.field === 'GROUP_TYPE') {
        //     return {
        //       ...column,
        //       valueOptions: column.valueOptions,
        //     };
        //   }
        //   // if (column.field === 'GROUP_NAME') {
        //   //   return {
        //   //     ...column,
        //   //     valueOptions:(params) => groupNameOptions[dataGroup.find((row) => row.id === params.id).GROUP_TYPE],
        //   //   };
        //   // }
        //   return column;
        // })}
        pageSize={5}
        density="compact"
        apiRef={apiRef}
        getRowId={(row) => row.ACH_CODE}
        rowsPerPageOptions={[50, 100, 200]}
        onCellEditStop={(params) => handleGroupTypeChange(params.id, params.value,params.row,params.field)}
        
        sx={{ p: 0, fontSize: '16px' }}
      />}
    </Paper>
    </JumboCardQuick>

  );
};
AccHead.Modulename = 'AccHead';


export default AccHead;

